export enum TranslationKey {

    aboutToBeBlocked = "aboutToBeBlocked",
    acceptedCurrency = "acceptedCurrency",
    accountNumber = "accountNumber",
    addCard = "addCard",
    additionalPaymentMethods = "additionalPaymentMethods",
    amount = "amount",
    apply = "apply",
    approved = "approved",
    back = "back",
    backToPlatform = "backToPlatform",
    backToTrade = "backToTrade",
    bankAddress = "bankAddress",
    bankName = "bankName",
    beneficiaryName = "beneficiaryName",
    callMe = "callMe",
    cancel = "cancel",
    cancelRequest = "cancelRequest",
    cardNumberWrong = "cardNumberWrong",
    choosePreferredBankCurrency = "choosePreferredBankCurrency",
    chooseYourDepositAmount = "chooseYourDepositAmount",
    chooseYourPaymentMethod = "chooseYourPaymentMethod",
    chooseYourProvider = "chooseYourProvider",
    clientDeclaration = "clientDeclaration",
    completeLater = "completeLater",
    completed = "completed",
    confirm = "confirm",
    continueWith = "continueWith",
    continue_ = "continue_",
    copiedToClipboard = "copiedToClipboard",
    creditCard = "creditCard",
    creditCardNumber = "creditCardNumber",
    creditCardType = "creditCardType",
    currency = "currency",
    cvvInfo = "cvvInfo",
    date = "date",
    dateOfBirth = "dateOfBirth",
    deposit = "deposit",
    depositAmount = "depositAmount",
    depositMinAmount = "depositMinAmount",
    depositPageSubtitleDepositSuccessful = "deposit.page.subtitle.DepositSuccessful",
    depositPageSubtitleDepositTopUp = "deposit.page.subtitle.DepositTopUp",
    depositPageTitleDepositSuccessful = "deposit.page.title.DepositSuccessful",
    depositPageTitleDepositTopUp = "deposit.page.title.DepositTopUp",
    documentTitleDepositSuccessful = "document.title.DepositSuccessful",
    documentTitleDepositTopUp = "document.title.DepositTopUp",
    errorAmount = "error.amount",
    errorAmountLarge = "error.amount.large",
    errorCardCvv = "error.cardCvv",
    errorCardCvvLength = "error.cardCvv.length",
    errorCardExpiration = "error.cardExpiration",
    errorCardExpirationExpired = "error.cardExpirationExpired",
    errorCardName = "error.cardName",
    errorCardNameRegexp = "error.cardName.regexp",
    errorCardNumber = "error.cardNumber",
    errorDepositLimits = "error.depositLimits",
    errorIdCard = "error.idCard",
    expirationDate = "expirationDate",
    formFieldCardCvv = "form.field.cardCvv",
    formFieldCardName = "form.field.cardName",
    formFieldCardNumber = "form.field.cardNumber",
    formFieldIdCard = "form.field.idCard",
    formFieldMonth = "form.field.month",
    formFieldPromotionCode = "form.field.promotionCode",
    formFieldYear = "form.field.year",
    fullName = "fullName",
    goToPlatform = "goToPlatform",
    gotIt = "gotIt",
    great = "great",
    guaranteedSafe = "guaranteedSafe",
    iAgree = "iAgree",
    iAgreeTo = "iAgreeTo",
    iban = "iban",
    importantNotice = "importantNotice",
    leave = "leave",
    liveChat = "liveChat",
    mm = "mm",
    mmYY = "mmYY",
    next = "next",
    nextStep = "nextStep",
    no = "no",
    ok = "ok",
    optional = "optional",
    or = "or",
    pending = "pending",
    pendingApproval = "pendingApproval",
    personalReferenceNumber = "personalReferenceNumber",
    pleaseSpecifyReason = "pleaseSpecifyReason",
    poweredBy = "poweredBy",
    print = "print",
    proceed = "proceed",
    readServiceAgreement = "readServiceAgreement",
    reason = "reason",
    receiptNumber = "receiptNumber",
    redirectToAPM = "redirectToAPM",
    referenceNumberDescription = "referenceNumberDescription",
    reject = "reject",
    rejected = "rejected",
    replaceFile = "replaceFile",
    required = "required",
    savedCards = "savedCards",
    scrollBottomToAcceptTerms = "scrollBottomToAcceptTerms",
    select = "select",
    sendDetailsViaEmail = "sendDetailsViaEmail",
    serverErrorGeneral = "server.error.general",
    serviceAgreement = "serviceAgreement",
    specifiedPepUs = "specifiedPepUs",
    start = "start",
    submit = "submit",
    submitCNMV = "submitCNMV",
    swift = "swift",
    termsAndConditions = "termsAndConditions",
    topUp = "topUp",
    topUpAgain = "topUpAgain",
    topUpDifferentAmount = "topUpDifferentAmount",
    topUpYourAccount = "topUpYourAccount",
    transactionId = "transactionId",
    transferDetailsSentToEmail = "transferDetailsSentToEmail",
    tryAgain = "tryAgain",
    upload = "upload",
    uploadAll = "uploadAll",
    uploadFile = "uploadFile",
    weReallySorry = "weReallySorry",
    willDoLater = "willDoLater",
    willTryLater = "willTryLater",
    wireTransfer = "wireTransfer",
    yes = "yes",
    yy = "yy",
}
